import React, { useEffect, useRef, useState } from "react";

import { withSnackbar } from "notistack";
import RadioBtn from "components/Custom/RadioBtn";
import TxtRow from "components/Custom/TxtRow";
import { ERRORS, LABELS, SUCCESS, TITLES, WARNINGS } from "common/lables";
import ExcelGrid from "components/Custom/ExcelGrid";
import Loader from "components/Custom/Loader";
import UiDialog from "components/Custom/UiDialog";
import Btn from "components/Custom/Btn";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { COLORS } from "common/colors";
import AutoComplete from "components/Custom/AutoComplete";

import { GEO_APIs } from "../../../apihandlers/geography";
import { DEFAULTS, NOTIFY } from "common/config";
import { COMMON_JS } from "common/scripts";

const State = (props: any) => {
  const { setDashMenu } = props;

  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState<boolean>(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [countries, setCountries] = useState<any>([]);

  const countriesRef: any = useRef(null);

  const [columns, setColumns] = useState<any>([
    {
      key: "slNo",
      name: LABELS.SL_NO,
      type: "number",
      width: "5%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "stateName",
      name: LABELS.STATE_NAME,
      type: "number",
      width: "35%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "countryName",
      name: LABELS.COUNTRY_NAME,
      type: "number",
      width: "35%",
      editable: false,
      sortable: true,
      align: "center",
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE_STATUS,
      type: "number",
      width: "20%",
      editable: false,
      sortable: true,
      align: "center",
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      type: "text",
      width: "5%",
      editable: false,
      sortable: true,
      align: "left",
      renderCell: ({ row }: any) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton className="iconBtn" onClick={() => onEditRow(row)}>
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ]);
  useEffect(() => {
    getCountries();
  }, []);

  const getCountries = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
      activeStatus: true,
    };

    GEO_APIs.getCountries(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.countryName,
          };
        });
        setCountries(list);

        getRows();
      }
    });
  };
  const getRows = () => {
    const args = {
      pageNo: 1,
      pageLength: DEFAULTS.PAGE_LENGTH,
    };

    GEO_APIs.getStates(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < list.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
          //   if (list[i]["loadingOnlyStatus"]) {
          //     list[i]["loadingOnlyStatus"] = "Yes";
          //   } else {
          //     list[i]["loadingOnlyStatus"] = "No";
          //   }
        }
        setRows(list);
        setLoading(false);
      }
    });
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };
  const reloadGrid = () => {
    setRows(null);
    getRows();
    console.log("selected row", selectedRow);
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log("SELECTED ROW", selectedRow);
  };

  const manageState = () => {
    const stateName = (
      document.getElementById("name") as HTMLInputElement
    ).value.trim();
    const countryId = countriesRef.current.selectedValue.id;
    let ele = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const activeStatus = ele ? ele.value : "";
    const args = {
      id: selectedRow.id || -1,
      stateName,
      countryId,
      activeStatus,
    };
    if (!stateName) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }

    if (!countryId) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_FILL_MANDATORY_FIELDS
      );
      return;
    }
    setIsSubmit(true);
    GEO_APIs.manageState(args).then((res) => {
      setIsSubmit(false);

      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
    console.log("args", args);
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.STATE}</li>
        </ul>
        <h4>{TITLES.STATE}</h4>
        {/* <p>{SUB_TITLES.USERS}</p> */}
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={TITLES.STATE}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + TITLES.STATE + ": " + selectedRow.id
              : "Add " + TITLES.STATE
          }
          open={true}
          size={"md"}
          onClose={() => {
            setManageDialog(false);
          }}
        >
          <div className="flexColumn">
            <div className="formGroup ">
              <TxtRow
                id={"name"}
                label={LABELS.STATE}
                defaultValue={selectedRow.id ? selectedRow.stateName : ""}
                type={"text"}
                required={true}
                disabled={isSubmit}
              />
            </div>
            <div className="formGroup ">
              <label>
                {LABELS.COUNTRY}
                <span className="red">{" *"}</span>
              </label>

              <AutoComplete
                list={countries}
                childRef={countriesRef}
                defaultValue={
                  selectedRow.id
                    ? {
                        id: selectedRow.countryId,
                        label: selectedRow.countryName,
                      }
                    : null
                }
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup">
              <label>{LABELS.STATUS}</label>
              <RadioBtn
                list={[
                  {
                    id: "true",
                    value: "true",
                    label: LABELS.ACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "Yes"
                      : true,
                    disabled: false,
                  },
                  {
                    id: "false",
                    value: "false",
                    label: LABELS.INACTIVE,
                    checked: selectedRow.id
                      ? selectedRow.activeStatus === "No"
                      : false,
                    disabled: false,
                  },
                ]}
                row={true}
                name={"activeStatus"}
                disabled={isSubmit}
              />
            </div>

            <div className="formGroup submitBtnWrapper">
              <div className="width45 flexRowJustify">
                <Btn
                  text={LABELS.SAVE}
                  onClick={manageState}
                  loading={isSubmit}
                />
                <Btn
                  text={LABELS.CANCEL}
                  bgColor={COLORS.DIM_DARK_GRAY}
                  onClick={() => setManageDialog(false)}
                  loading={isSubmit}
                />
              </div>
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};
export default withSnackbar(State);
